var map = {
	"./account--icon.svg": "./src/assets/shortcuts-icons/account--icon.svg",
	"./developers--icon.svg": "./src/assets/shortcuts-icons/developers--icon.svg",
	"./directory--icon.svg": "./src/assets/shortcuts-icons/directory--icon.svg",
	"./documents--icon.svg": "./src/assets/shortcuts-icons/documents--icon.svg",
	"./folios--icon.svg": "./src/assets/shortcuts-icons/folios--icon.svg",
	"./metrics--icon.svg": "./src/assets/shortcuts-icons/metrics--icon.svg",
	"./notifications--icon.svg": "./src/assets/shortcuts-icons/notifications--icon.svg",
	"./pos--icon.svg": "./src/assets/shortcuts-icons/pos--icon.svg",
	"./purchases--icon.svg": "./src/assets/shortcuts-icons/purchases--icon.svg",
	"./reports--icon.svg": "./src/assets/shortcuts-icons/reports--icon.svg",
	"./sii--icon.svg": "./src/assets/shortcuts-icons/sii--icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/shortcuts-icons sync recursive ^\\.\\/.*\\-\\-icon\\.svg$";